import React, { Fragment } from 'react'
import { asField } from 'informed'
import { withApollo } from '@apollo/client/react/hoc'
import { compose } from 'recompose'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import { useMutation, asyncClientQuery, updateQuery } from 'components/graphql'
import { DataTable } from 'components/DataTable'
import { Checkbox } from 'components/forms'
import { withFieldSubmit } from 'components/forms/Form'
import { deleteProductList } from '../../../gql/mutation'
import { listProductLists, listProductListItems } from '../../../gql/query'

const FieldLists = ({ fieldState: { value = [] }, fieldApi, onDelItem, data, smartSubmit, ...props }) => (
	<ListsTable
		{...props}
		data={data}
		onValueChange={(id, val) => {
			const newVal = val ? [...value, { productListId: id }] : value.map(item => Number(item.productListId) === Number(id) ? { id: item.id } : item)
			fieldApi.setValue(newVal)
			smartSubmit.submit(newVal)
		}}
		onAllChange={val => {
			const changedData = val ?
				data.map(({ id }) => value.find(formItem => Number(formItem.productListId) === Number(id)) || { productListId: id })
				:
				value.map(({ id }) => ({ id }))
			fieldApi.setValue(changedData)
			smartSubmit.immidiateSubmit(changedData)
		}}
		onDelItem={id => {
			const newVals = value.map(item => Number(item.productListId) === Number(id) ? { id: item.id } : item)
			fieldApi.setValue(newVals)
			smartSubmit.immidiateSubmit(newVals)
			onDelItem(id)
		}}
		fieldValue={value} />
)

const ListsTable = ({ data: tableData, onRowClick, fieldValue, onValueChange, onAllChange, onAdd, onDelItem, productId, client }) => {
	const [t] = useTranslation()
	const [onDel] = useMutation(deleteProductList)
	const isAllChecked = tableData.length === fieldValue.length && fieldValue.every(({ id, ...restVals }) => Object.keys(restVals).length)
	const columns = [
		{
			accessor: 'id',
			show: false
		}, {
			Header: () => (
				<Checkbox
					noForm
					checked={isAllChecked}
					onChange={e => onAllChange(e.target.checked)}
					label={t('product_section.strings.list_name')}
					stopPropagation
					styleInverted
				/>),
			accessor: 'name',
			Cell: ({ value, original: { id } }) => (
				<Fragment>
					<Checkbox
						noForm
						checked={fieldValue.some(item => item && Number(item.productListId) === Number(id))}
						onChange={e => onValueChange(id, e.target.checked)}
						stopPropagation />
					{value}
				</Fragment>)
		}
	]
	// Used to re-render DataTable for recall cell renderer in 'columns' with new values
	// including replacement of optimisticResponse value
	const key = fieldValue.length + tableData.reduce((sum, { id }) => sum + Number(id), 0)

	return(
		<DataTable
			key={key}
			data={tableData}
			columns={columns}
			onRowClick={onRowClick}
			withSearch
			selectRow
			mutateRow={{
				beforeRowMutate: async id => {
					const { data = {}, queryField } = await asyncClientQuery(client, listProductListItems, { fetchPolicy: 'network-only', variables: { filter: { productListId: id } } })
					const queryRes = data[queryField]
					const prodNames = Array.isArray(queryRes) && queryRes.length ?
						queryRes.filter(item => get(item, 'productId') !== productId)
							.map(({ product = {} }, i) => <li key={i}><b>{`${product.name}`}</b></li>)
						: null
					return prodNames ? { text: <Fragment>Deleting list is used in products: <ul style={{ textAlign: 'left', maxHeight: '5em', overflowY: 'scroll' }}>{prodNames}</ul>Are you sure?</Fragment> }
						: {}
				},
				onRowMutate: id => {
					onDel({
						variables: { id },
						update: updateQuery({ query: listProductLists }, (draft, { mutationResult, readQuery = [], queryField }) => {
							draft[queryField] = readQuery.filter(({ id: cachedId }) => cachedId.toString() !== mutationResult.id.toString())
						}),
						optimisticResponse: {
							cashAssist: {
								deleteProductList: {
									__typename: 'ProductList',
									id
								},
								__typename: 'CA_Mutation'
							}
						}
					})
					onDelItem(id)
				}
			}}
			onAddRecord={onAdd}
		/>
	)
}

export default compose(withApollo, asField, withFieldSubmit)(FieldLists)
